import { useTranslations } from '@vocab/react';
import { IconNewWindow, TextLink } from 'braid-design-system';
import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { JOB_AD_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import { getAuNzOnlyCountryCode } from 'src/app/utils/country';
import { log } from 'src/app/utils/logging';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';
import { usePostedJobIdSelector } from 'src/app/v1/views/hooks/usePostedJobIdSelector';
import type { AppState } from 'src/types/appState';

import translations from './.vocab';

export const ViewAdLink = () => {
  const { countryCode } = useSelector(
    (state: AppState) => ({
      countryCode: getAuNzOnlyCountryCode(
        state.session.hirerAccount.nation.toLowerCase(),
      ),
    }),
    shallowEqual,
  );

  const { t } = useTranslations(translations);

  const { getCandidateJobRoute } = useLocalisedRoutes();

  const postedJobId = usePostedJobIdSelector();

  if (!postedJobId || !countryCode) {
    return null;
  }

  const jobUrl = getCandidateJobRoute();

  if (!jobUrl) {
    log.error('ViewAdLink | no jobUrl generated:', {
      jobId: postedJobId,
      countryCode,
    });
    return null;
  }

  const onLinkClick = () => {
    const eventData = {
      eventName: JOB_AD_PRESSED,
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  };

  return (
    <TextLink
      href={jobUrl}
      rel={t('view-ad-link-rel')}
      target="_blank"
      onClick={onLinkClick}
    >
      {t('view-ad-link-text')} <IconNewWindow />
    </TextLink>
  );
};
